<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          to="/add-reception-notes"
          v-if="auth.can('ADD_RECEPTION') && auth.can('RECEPTION')"
        >
          Nouveau bon de réception
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
        <!-- <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          @click="addHcReception"
          v-if="auth.can('ADD_RECEPTION') && auth.can('RECEPTION')"
        >
          Réception Hors Casa
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button> -->
      </div>
      <div class="d-sm-flex align-items-center"></div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row mb-20">
        <div class="col-md-6 d-flex align-items-center">
          <label>Voir</label>
          <v-select
            v-model="filters.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @update:modelValue="getRecords()"
          />
          <label>sur {{ filters.total }} entités</label>
        </div>
        <div class="col-md-6 d-flex align-items-center">
          <input
            type="text"
            class="form-control shadow-none text-black rounded-0"
            placeholder="Chercher"
            @change="filter()"
            @input="handleInput"
            v-model="filters.searchTerm"
          />
        </div>
      </div>

      <vue-good-table :columns="columns" :rows="rows" :loading="isLoader">
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <template #table-row="props">
          <span v-if="props.column.field === 'note_ref'" class="text-nowrap">
            <b>{{ props.row.note_ref }}</b>
          </span>

          <span v-else-if="props.column.field === 'note_customer_name'">
            <template v-if="props.row.note_type == 'CSTMR'">
              <b>{{ props.row.note_customer_name }}</b>
            </template>
            <template v-if="props.row.note_type == 'GLOBAL'">
              <b>GLOBAL</b>
            </template>
            <template v-if="props.row.note_type == 'STOCK'">
              <b>STOCK</b>
            </template>
          </span>

          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            {{ getDate(props.row.created_at) }}<br />
            <span>{{ props.row.note_by_name }}</span>
          </span>
          <span
            v-else-if="props.column.field === 'note_saved_time'"
            class="text-nowrap"
          >
            <template v-if="props.row.note_saved_time != null">
              {{ getDate(props.row.note_saved_time) }}<br />
            </template>
            <span>{{ props.row.note_saved_by_name }}</span>
          </span>

          <template v-else-if="props.column.field === 'note_saved'">
            <span
              v-if="props.row.note_saved == 0"
              :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                props.row.note_saved
              )}`"
              class="text-capitalize"
            >
              Nouveau
            </span>
            <span
              v-else
              :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                props.row.note_saved
              )}`"
              class="text-capitalize"
            >
              Enregistré
            </span>
          </template>

          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li v-if="auth.can('RECEPTION')">
                  <router-link
                    v-if="props.row.note_type == 'CSTMR'"
                    class="dropdown-item d-flex align-items-center"
                    :to="{
                      name: 'AddReceptionHCPage',
                      params: {
                        id: props.row.note_customer,
                        refNote: props.row.note_ref,
                      },
                    }"
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </router-link>
                  <router-link

                    v-else-if="props.row.note_type == 'GLOBAL'"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    :to="{
                      name: 'AddReceptionGlobalPage',
                      params: {
                        id: props.row.id,
                        refNote: props.row.note_ref,
                      },
                    }"
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </router-link>
                  <router-link
                    v-else-if="props.row.note_type == 'STOCK'"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    :to="{
                      name: 'AddReceptionStockPage',
                      params: {
                        id: 0,
                        refNote: props.row.note_ref,
                      },
                    }"
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </router-link>
                </li>

                <li
                  v-if="
                    auth.can('RECEPTION') &&
                    props.row.note_saved != 1 &&
                    props.row.note_parcels != 0
                  "
                >
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="showModal(props.row)"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Détails
                  </a>
                </li>

                <li
                  v-if="
                    auth.can('RECEPTION') &&
                    props.row.note_saved != 1 &&
                    props.row.note_parcels != 0
                  "
                >
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="saveReception(props.row)"
                  >
                    <i
                      class="flaticon-diskette lh-1 me-8 position-relative top-1"
                    ></i>
                    Enregistrer
                  </a>
                </li>
                <li v-if="auth.can('RECEPTION') && props.row.note_saved == 1">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="openReception(props.row)"
                  >
                    <i
                      class="flaticon-unlock lh-1 me-8 position-relative top-1"
                    ></i>
                    Ouvrir
                  </a>
                </li>

                <li
                  v-if="
                    auth.can('RECEPTION') &&
                    props.row.note_saved != 1 &&
                    props.row.note_parcels == 0
                  "
                >
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="destroyBrc(props.row)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </a>
                </li>
                <li>
                  <a
                    v-if="
                      auth.can('RECEPTION') &&
                      props.row.note_stock_total_parcel != 0
                    "
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="getPDF(props.row)"
                  >
                    <i
                      class="flaticon-printer lh-1 me-8 position-relative top-1"
                    ></i>
                    PDF
                  </a>
                </li>
              </ul>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="filters"
        :offset="9"
        @paginate="getRecords"
      />
    </div>
  </div>

  <div class="modal fade" id="detailBonModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Détails du Bon : {{ noteRow?.note_ref }}</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <SaveSingleParcel 
            v-if="noteRow && Object.keys(noteRow).length != 0" :key="noteRow.id"
            :noteRow="noteRow"
            :getRecords="getRecords"
            :type="true"
            :isOpen="isOpen"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import { useAuthStore } from "@/stores/auth";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import { dt } from "@fullcalendar/core/internal-common";
import router from "@/router";
import SaveSingleParcel from "@/components/Notes/Reception/SaveSingleParcel.vue";

export default {
  name: "ListeNotes",
    components: { SaveSingleParcel },

  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);
    const noteRow = ref(null);
    const columns = [
      {
        label: "Réf",
        field: "note_ref",
      },

      {
        label: "Agence",
        field: "note_agency_name",
      },
      {
        label: "Pour",
        field: "note_customer_name",
      },
      {
        label: "Date de création",
        field: "created_at",
        width: "180px",
      },
      {
        label: "Date d'enregistrement",
        field: "note_saved_time",
      },
      {
        label: "Statut",
        field: "note_saved",
      },
      {
        label: "Colis",
        field: "note_parcels",
      },

      {
        label: "Action",
        field: "action",
      },
    ];
    const filters = reactive({
      searchTerm: "",
      searchCustomer: "",
      searchStatut: "",
      searchDateType: "",
      searchSDate: "",
      searchEDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    onMounted(() => {
      getRecords();
    });
    async function getRecords(page =1) {
      isLoader.value = true;  
      filters.current_page = page;
      try {
        const response = await api.get(
          `/api/auth/reception_list?searchCustomer=${filters.searchCustomer}&searchDateType=${filters.searchDateType}&searchStatut=${filters.searchStatut}&searchSDate=${filters.searchSDate}&searchEDate=${filters.searchEDate}&searchTerm=${filters.searchTerm}&page=${filters.current_page}&per_page=${filters.per_page}`
        );

        rows.value = response.data.users.data;
        Object.assign(filters, response.data.users);
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      } finally {
        isLoader.value = false;
      }
    }

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }
    function resolveUserStatusVariant(status) {
      if (status == 0) return "warning";
      if (status == 1) return "info";
      return "danger";
    }

    function filter() {
      //   filters.searchCustomer = customer_filter.id
      //   filters.searchStatut = status_filter
      //   filters.searchStore = store_filter.id
      //   filters.searchSDate = ($refs.myInput.dateRange.start == undefined || $refs.myInput.dateRange.start == 'undefined') ? '' : convert($refs.myInput.dateRange.start)
      //   filters.searchEDate = ($refs.myInput.dateRange.end == undefined || $refs.myInput.dateRange.end == 'undefined') ? '' : convert($refs.myInput.dateRange.end)
      filters.current_page = 1;
      getRecords();
    }
    function convert(str) {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }
    function removeFilter() {
      //   filters.searchCustomer = filters.searchStatut = filters.searchStore = "";
      //   customer_filter = store_filter = { id: '', name: '' }
      //   date_filter = status_filter = type_date_filter = ''
      //   $refs.myInput.dateRange = {}
      filters.current_page = 1;
      getRecords();
    }
    function handleInput() {
      //   // Clear previous debounce timer
      //   clearTimeout(debounceTimer);

      //   // Set a new debounce timer
      //   debounceTimer = setTimeout(() => {
      //     if (!searchTerm || searchTerm === '') {
      //     filters.searchTerm = searchTerm
      //     filter()
      //   } else if (searchTerm && searchTerm.length > 4) {
      //     filters.searchTerm = searchTerm
      //     filter()
      //   }
      //   }, 500); // Adjust the delay (in milliseconds) as needed
      filter();
    }

    async function destroyBrc(row) {
      const data = new FormData();
      data.append("reception_note_id", row.id);
      data.append("cstmr_id", row.note_customer);

      const result = await Swal.fire({
        text: "Vous voulez supprimer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`/api/auth/DestroyBrc`, data);

          if (res.data.message === "success") {
            showToast("Bon de réception est bien supprimé", "success");

            getRecords(); // 🔹 if you are using Composition API. If still in Options API, keep `getRecords()`.
          } else if (res.data.message === "Issaved") {
            showToast("Vous pouvez pas le supprimer!", "error");
          }
        } catch (error) {
          console.error("Erreur suppression BL:", error);
          showToast("Something went wrong! Veuillez réessayer", "error");
        }
      }
    }

    async function saveReception(row) {
      try {
        let data = new FormData();
        data.append("UserID", user?.id);
        data.append("ref_note", row.note_ref);
        data.append("cstmr", row.note_customer);
        const res = await api.post(`/api/auth/SaveBrc`, data);

        if (res.data.message === "success") {
          showToast("Bon de reception est bien enregistré", "success");
          getRecords(); // 🔹 if Composition API. Use `getRecords()` if Options API.
        } else if (res.data.message == "no edit") {
          showToast("Bon de reception est déjà enregistré", "error");
        } else {
          showToast("Erreur, merci de réessayer encore!", "error");
        }
      } catch (error) {
        console.error("Erreur API SaveBL:", error);
        showToast("Something went wrong! Veuillez réessayer", "error");
      }
    }

    async function getPDF(row) {
      try {
        const response = await api.get(`/api/auth/BCRPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF",
        });
      }
    }

    async function openReception(row) {
      try {
        let data = new FormData();
        data.append("UserID", user?.id);
        data.append("ref_note", row.note_ref);
        data.append("cstmr", row.note_customer);
        const res = await api.post(`/api/auth/OpenBrc`, data);

        if (res.data.message === "success") {
          showToast("Bon de reception est bien modifié", "success");
          getRecords(); // 🔹 if Composition API. Use `getRecords()` if Options API.
        } else {
          showToast("Erreur, merci de réessayer encore!", "error");
        }
      } catch (error) {
        console.error("Erreur API SaveBL:", error);
        showToast("Something went wrong! Veuillez réessayer", "error");
      }
    }

    async function tickets4PDF(row) {
      try {
        const response = await api.get(`/api/auth/TicketsInv4PDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération Tickets4PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF (4 tickets)",
        });
      }
    }
        const isOpen = ref(false);

    function showModal(row) {
      noteRow.value = {};
      // noteBmBL=[];
      noteRow.value = row;

      const modalEl = document.getElementById("detailBonModal");
      if (modalEl) {
        isOpen.value = true;
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    async function addHcReception() {
      try {
        let data = new FormData();
        data.append("cstmr_id", "0");
        data.append("agency_id", "0");
        data.append("agency_name", "");
        data.append("id_zone", "0");
        data.append("zone_name", "");
        data.append(
          "user_id",
          user?.id.toString()
        );
        data.append(
          "user_name",
          user?.name
        );
        data.append("type", "HC");
        // isLoader = true;
        const res = await api.post(`/api/auth/Add_BRC`, data);
        // isLoader = false;
        if (res.data.message === "success") {
          // router.push(
          //   `/edit-global-reception/${res.data.BrcRef.id}/${res.data.BrcRef.note_ref}`
          // );
          // // Or:
          router.push({ name: 'AddReceptionGlobalPage', params: { id: res.data.BrcRef.note_customer, refNote: res.data.BrcRef.note_ref } });
        }
      } catch (error) {
        // isLoader = false; // make sure loader stops even on error
        showToast("Something went wrong! Veuillez réessayer", "error");
        console.log( error);
      }
    }

    return {
      auth,
      rows,
      isLoader,
      columns,
      filters,
      getRecords,
      getDate,
      resolveUserStatusVariant,
      filter,
      convert,
      removeFilter,
      handleInput,
      showModal,
      destroyBrc,
      saveReception,
      getPDF,
      openReception,
      addHcReception,
      noteRow,
      isOpen
    };
  },
};
</script>